import $ from 'jquery';
import debounce from './utils/debounce';
import changeWindowUrl from './utils/change-url';
import empty from "./utils/empty";
import ContentsList from "./contents-list";

class SectionsList {
    constructor($content, $selector, $contentsList) {
        this.$content = $content;
        this.$list = $selector;
        this.$contentsList = $contentsList;
        this.$header = $('.js-header');
        this.$sectionLinks = $('.js-sub-contents-list__item');
        this.headingPositions = [];

        this.init();
        this.$sectionLinks.on('click', $.proxy(this.clickListItem, this));
        // this.$sectionLinks.on('click', $.proxy(this.contentsListClose, this));

    }

    scrollToHeading(hash, $parentChapterItem) {
        let top = 0;
        let changeHash = false;
        if (hash.indexOf('table-') < 0 || hash.indexOf('figure-') < 0) {
            let $heading = this.$content.find(hash);

            if (!$heading.length && typeof $parentChapterItem !== 'undefined') {
                const parentChapterHash = $parentChapterItem.attr('href');
                changeWindowUrl(parentChapterHash, true, false);

                const $parentChapter = $('#' + parentChapterHash);
                if ($parentChapter.length && $parentChapter.find(hash)) {
                    $heading = $parentChapter.find(hash);
                }
            }

            if ($heading.length) {
                top = $heading.offset().top;
            }
        } else {
            const $component = this.$content.find(hash);
            if ($component.length) {
                changeHash = true;
                top = $component.offset().top;
            }
        }

        if (top) {
            const headerHeight = this.$header.outerHeight(true);

            $('body,html').animate({
                scrollTop: top - headerHeight
            }, 1000, 'swing', () => {
                if (changeHash) {
                    changeWindowUrl(hash, true, false);
                }
            });
        }
    }

    setActiveClass($item, $parentChapterItem) {
        $('.is-active').removeClass('is-active');
        $item.addClass('is-active');
        $parentChapterItem.addClass('is-active');
    }

    convertToSlug(Text) {
        return Text
            .toLowerCase()
            .replace(/[^\w -]+/g, '')
            .replace(/ +/g, '-');
    }

    init() {
        /**
         * Window events
         */
        $(window).off('load.sections-list').on('load.sections-list', () => {
            /**
             * Scroll to heading when hash url is passed
             */
            if (window.location.hash) {
                const hash = window.location.hash.substring(1);

                this.scrollToHeading('#' + hash);

                //set loaded heading with active class
                const $link = this.$sectionLinks.filter(function () {
                    return $(this).attr('href') === ('#' + hash);
                });

                if ($link !== undefined && $link.length) {
                    $link.addClass('is-active');
                }
            }

            if (!this.$list.find('li').length) {
                let headingPositions = this.getHeadingPositions();

                if (!headingPositions.length) {
                    headingPositions = this.resetHeadingPositions();
                }

                if (!headingPositions.length) {
                    this.$content.find('.js-sub-contents').addClass('is-hidden');
                }

            }
        }).off('load.sections-list-reset resize.sections-list-reset').on('load.sections-list-reset resize.sections-list-reset', debounce(() => {
            this.resetHeadingPositions();
        }, 100))
            .off('scroll.sections-list').on('scroll.sections-list', debounce(() => {
            /**
             * Highlight the current chapter as you scroll
             */
            const headingPositions = this.getHeadingPositions();
            let i;
            const highlightOffset = 100;
            const scrollPos = $(window).scrollTop();
            let matchedHeading = false;

            for (i = 0; i < headingPositions.length; i += 1) {
                if ((scrollPos + highlightOffset) > headingPositions[i]['headingTop']) {
                    changeWindowUrl('#' + headingPositions[i]['id'], true, true);
                    matchedHeading = true;
                }
            }

            if (headingPositions.length && !matchedHeading) {
                changeWindowUrl('', true, true);
            }
        }, 100));

        $(window).trigger('load.sections-list');
        $(window).trigger('load.sections-list-reset');
    }

    getHeadingPositions() {
        return this.headingPositions;
    }

    resetHeadingPositions() {
        const $contentHeadings = this.$content.find('.js-subheading');
        const convertToSlug = this.convertToSlug;
        const headingPositions = [];

        $contentHeadings.each(function () {
            let id = $(this).attr('id');
            const headingTop = Math.floor($(this).offset().top);

            // If no ID is set, add one
            if (!id) {
                id = convertToSlug($(this).text());
                $(this).attr('id', id);
            }

            // Add to array of heading positions
            headingPositions.push({
                'id': id,
                'headingTop': headingTop - 100
            });
        });

        this.headingPositions = headingPositions;

        return headingPositions;
    }

    getContent() {
        return this.$content;
    }

    clickListItem(e) {
        e.preventDefault();

        const $item = $(e.currentTarget);
        const href = $item.attr('href');
        const $parentChapterItem = $item.parents('.js-contents-list__item').first().find('.js-contents-list__link');

        this.scrollToHeading(href, $parentChapterItem);
        this.setActiveClass($item, $parentChapterItem);
    }

}

export default SectionsList;
